// extracted by mini-css-extract-plugin
module.exports = {"container":"PickupAssigned_container__NOZz2","box":"PickupAssigned_box__2x_KD","backIcon":"PickupAssigned_backIcon__1Qvj-","textContainer":"PickupAssigned_textContainer__1R_17"};